































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Building, BuildingsApi, PropertiesApi, Property } from 'performo-api';
import { mapGetters } from 'vuex';
import { handleApiError } from '@/ApiHelpers';

@Component({
  components: {},
  computed: mapGetters({
    api: 'buildingsApi',
    propertiesApi: 'propertiesApi'
  })
})
export default class Location1Picker extends Vue {
  @Prop({ required: false, default: 'building-picker' })
  private id?: string;

  @Prop({ required: false, type: Boolean, default: false })
  private required?: boolean;

  @Prop({ required: false, type: Boolean, default: false })
  private hideAll?: boolean;

  @Prop({ required: false, type: Boolean, default: false })
  private hideLabel?: boolean;

  @Prop({ required: true })
  private value!: string;

  @Prop({ required: false })
  private intendedValue!: string;

  @Prop({ required: true, type: String })
  private propertyId!: string;

  @Prop({ required: false, default: 'Building' })
  private labelOverride?: string;

  get getValue() {
    return this.value;
  }

  private api!: BuildingsApi;
  private propertiesApi!: PropertiesApi;

  private buildings: Building[] = [];
  private property: Property = {};

  get buildingsSorted() {
    if (!this.buildings) {
      return null;
    }
    return this.buildings.sort((a, b) => {
      if (a.buildingName && b.buildingName) {
        return a.buildingName.localeCompare(b.buildingName);
      }
      return 0;
    });
  }

  private get location1Label() {
    return this.property?.location1Label || this.labelOverride;
  }

  @Watch('propertyId', { immediate: true })
  private async propertyIdChanged() {
    this.property = await this.propertiesApi.getProperty({
      propertyId: this.propertyId
    });
    await this.loadBuildings();
  }

  private async loadBuildings() {
    // cannot load without an entity
    if (!this.propertyId) return;
    // load buildings from api
    const locationChoice = this.intendedValue;
    try {
      this.buildings = [];
      this.buildings = await this.api.queryBuildings({
        propertyId: this.propertyId,
        skip: 0, // skip none
        take: 10000 // pull in ten thousand
      });

      if (
        locationChoice &&
        this.buildings.filter((b) => b.buildingCode === locationChoice)
          .length === 1
      ) {
        this.$emit('input', locationChoice);
      }
    } catch (error) {
      handleApiError(error);
    }
  }

  private async mounted() {
    this.loadBuildings();
  }

  public buildingListContains(buildingCode: string) {
    let found = false;
    this.buildings.forEach((element) => {
      if (element.buildingCode === buildingCode) {
        found = true;
      }
    });
    return found;
  }
}
